export default {
  REACT_APP_BUCKET_NAME: "itugurme-comment-images",
  REACT_APP_REGION: "eu-central-1",
  REACT_APP_ACCESS: "AKIA2MCPK4JSFBWBY7A2",
  REACT_APP_SECRET: "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",
  DIRNAME: "images",
};
